import { formatIsoDateToAmerican } from '@helpers/formatIsoDateToAmerican';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import type { JobResponseDto } from 'app/API';
import { JOB_STATUSES_ENUM } from 'app/types/enums/jobStatuses';

export const ALL_JOBS_CSV_HEADERS = [
  'ID',
  'Title',
  'Due',
  'Assignee',
  'Organization',
  'Workspace',
  'Status',
  'Created',
  'Asr used',
  'Edits %',
];

export type TAllJobsCsvSource = Pick<
  JobResponseDto,
  'id' | 'name' | 'deadline' | 'assignee' | 'workspaceName' | 'status' | 'createdAt' | 'duration' | 'editingProgress'
>;

export const buildAllJobsCsvRows = (jobs: TAllJobsCsvSource[], organizationName: string) =>
  jobs.map((job) => ({
    id: job.id,
    title: job.name,
    due: job.deadline ? formatIsoDateToAmerican(job.deadline) : '',
    assignee: job.assignee ? `${job.assignee?.name} ${job.assignee?.lastname} (${job.assignee?.email})` : '',
    organization: organizationName,
    workspace: job.workspaceName ?? '',
    status: JOB_STATUSES_ENUM[job.status],
    created: getAmericanTime(job.createdAt),
    asr: job.duration || 0,
    editsPercent: Math.round(job.editingProgress || 0),
  }));
